import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/authService';
import { getErrorMessage } from '../utils/errorHandler';
import data from '../data/paomakeup';

const ForgotPasswordPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');
  const [showAlert, setShowAlert] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (formData) => {
    try {
      setIsSubmitting(true);
      setShowAlert(false);
      await forgotPassword({ email: formData.email });
      setAlertVariant('success');
      setAlertMessage('Se ha enviado un enlace para restablecer su contrasena a su correo electronico.');
      setShowAlert(true);
      setIsSent(true);
    } catch (err) {
      setAlertVariant('danger');
      setAlertMessage(getErrorMessage(err));
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="my-5">
      <Helmet>
        <title>Recuperar Contrasena - {data.title}</title>
      </Helmet>
      <Row className="justify-content-center">
        <Col sm={8} md={6} lg={5}>
          <h1 className="mb-4 text-center">Recuperar Contrasena</h1>
          <p className="text-center text-muted mb-4">
            Ingrese su correo electronico y le enviaremos un enlace para restablecer su contrasena.
          </p>

          {showAlert && (
            <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}

          {!isSent && (
            <Form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3" controlId="forgotEmail">
                <Form.Label>Correo electronico</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Ingrese su correo"
                  {...register('email', {
                    required: 'El email es requerido',
                    pattern: {
                      value: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,4}$/,
                      message: 'El email no es valido',
                    },
                  })}
                />
                <small className="text-danger">
                  {errors?.email && errors.email.message}
                </small>
              </Form.Group>

              <div className="d-grid mb-3">
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <span className="d-inline-flex align-items-center gap-2">
                      <Spinner animation="border" size="sm" /> Enviando...
                    </span>
                  ) : 'Enviar enlace'}
                </Button>
              </div>
            </Form>
          )}

          <p className="text-center">
            <Link to="/iniciar-sesion" className="text-decoration-none">
              Volver a iniciar sesion
            </Link>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordPage;
